import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-recurring-reservation-view",
  templateUrl: "./recurring-reservation-view.component.html",
  styleUrls: ["./recurring-reservation-view.component.css"],
})
export class RecurringReservationViewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
